import React from 'react';
import {
  Pagination as PaginationRoot,
  PaginationContent,
  PaginationItem,
  PaginationLink,
} from '@/Components/ui/pagination';

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const pageNumbers = [];
  
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  
  return (
    <PaginationRoot>
      <PaginationContent>
        {pageNumbers.map((number) => (
          <PaginationItem key={number}>
            <PaginationLink
              onClick={() => onPageChange(number)}
              isActive={currentPage === number}
              className="cursor-pointer"
            >
              {number}
            </PaginationLink>
          </PaginationItem>
        ))}
      </PaginationContent>
    </PaginationRoot>
  );
};

export default Pagination;
